import { LumberjackPlugin } from '@amzn/exs-elements/plugins';
import { getCurrentScriptUrl } from '~/src/assets/scripts/getCurrentScriptUrl';
import { classifyUserAgent, getDeviceType } from '~/src/assets/scripts/metrics';

export function getLumberjackPlugin(tagName: string) {
  const prod = getCurrentScriptUrl().hostname === 'cdn.elements.amazon';
  return LumberjackPlugin(
    prod ? 'SantosNebulaRosette' : 'SantosNebulaRosetteGamma',
    {
      properties: (element) => {
        const href = new URL(window.location.href);
        const targetId = element.getSetting('targetId');
        return {
          targetId,
          appId: `${tagName}:targetId=${targetId}:${href.host}${href.pathname}`,
        };
      },
      dimensions: [
        {
          ElementName: tagName,
        },
        {
          ElementName: tagName,
          UserAgentType: classifyUserAgent(),
        },
        {
          ElementName: tagName,
          UserAgentType: classifyUserAgent(),
          DeviceType: getDeviceType(),
        },
        {},
      ],
      /* Set both of these options to true to have metrics logged into the browser console */
      consoleOnlyLogging: false,
      localHostLogging: false,
    }
  );
}
